import { render, staticRenderFns } from "./StorageCreate.vue?vue&type=template&id=5ffc72ab&scoped=true&"
import script from "./StorageCreate.vue?vue&type=script&lang=js&"
export * from "./StorageCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffc72ab",
  null
  
)

export default component.exports